// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-interesting[data-v-66a00a68]{display:inline-flex;margin-bottom:24px;@media(max-width:360px){margin-bottom:16px}}.review-interesting__img[data-v-66a00a68]{border-radius:14px;margin-top:20px;max-width:343px;width:100%;@media(max-width:360px){//width:288px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
